<template lang="">
  <div>
    <div class="sidebox p-5">
      <p class="text-center p-5">
        <span class="points">{{ $store.getters['profile/achievement_points'] }}</span>
        <span class="pt">pt</span>
      </p>
      <Badges></Badges>
      <Achievements class="mt-5"></Achievements>
    </div>
  </div>
</template>

<script>
import Badges from "./Badges";
import Achievements from "./Achievements";

export default {
  components: {
    Badges,
    Achievements,
  },
};
</script>

<style lang="scss">
.sidebox {
  min-height: 900px;
  background: #fafafa;
  mix-blend-mode: normal;
  opacity: 0.8;
  /* Shadow/Level 1 */
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  font-size: 20px;
  line-height: 28px;

  .points {
    font-weight: 600;
    font-size: 5vw;
    max-font-size: 60px;
    line-height: 60px;
    color: #004e59 !important;
  }

  .pt {
    font-size: 32px;
    line-height: 38px;
    font-weight: 600;
    color: #004e59 !important;
  }
}
</style>
